import React from 'react';
import { Link } from 'react-router-dom';
import Box from '../../components/Common/Box';
import { CompanyResultsTable } from './components/CompanyResultsTable';
import { PERIOD_LABELS, periodShort, ResultsPageProps } from './resultsModel';

const selectStyle: React.CSSProperties = {
  padding: 6,
  borderRadius: 6,
  border: '1px solid var(--border-color)',
  background: 'var(--bg-box)',
  color: 'var(--text-heading)',
  fontSize: 14,
};

/** Vue desktop : table comparative complète (3 métriques × N / N-1 / variation). */
const DesktopResults: React.FC<ResultsPageProps> = ({
  periodOptions, yearOptions, selection, onPeriodChange, onExerciceChange,
  selectedOption, partialCoverage, results, loading, error,
}) => (
  <div style={{ padding: 20, maxWidth: 1600, margin: '0 auto', color: 'var(--text-heading)' }}>
    <Box>
      <div style={{ padding: 20 }}>
        <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap', marginBottom: 16 }}>
          <label style={{ fontSize: 14, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 8 }}>
            Période
            <select
              aria-label='Période'
              value={selection?.period_type ?? ''}
              disabled={!selection}
              onChange={e => onPeriodChange(e.target.value)}
              style={selectStyle}
            >
              {periodOptions.map(p => <option key={p} value={p}>{PERIOD_LABELS[p] ?? p}</option>)}
            </select>
          </label>
          <label style={{ fontSize: 14, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 8 }}>
            Exercice
            <select
              aria-label='Exercice'
              value={selection?.exercice ?? ''}
              disabled={!selection}
              onChange={e => onExerciceChange(Number(e.target.value))}
              style={selectStyle}
            >
              {yearOptions.map(o => (
                <option key={o.exercice} value={o.exercice}>
                  {o.exercice} — {o.published}/{o.total} publiées
                </option>
              ))}
            </select>
          </label>
          {loading && <span style={{ fontSize: 13, color: '#3b82f6' }}>⏳ Chargement...</span>}
          {partialCoverage && selectedOption && (
            <span role='status' style={{ fontSize: 13, color: '#FF6D00' }}>
              ⚠️ Publications en cours : {selectedOption.published}/{selectedOption.total} sociétés
            </span>
          )}
          <Link to='/calendar' style={{ marginLeft: 'auto', fontSize: 14, color: '#3b82f6' }}>
            Prochaines publications attendues →
          </Link>
        </div>

        {results ? (
          <CompanyResultsTable
            rows={results.rows}
            targetExercice={results.target_exercice}
            baseExercice={results.base_exercice}
          />
        ) : (
          <div style={{ padding: 40, textAlign: 'center', color: error ? '#ef5350' : 'var(--text-muted)' }}>
            {error ?? 'Chargement des résultats...'}
          </div>
        )}

        <div style={{ marginTop: 16, fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6 }}>
          {selection && (
            <>
              Comparaison {periodShort(selection.period_type)} {selection.exercice} / {periodShort(selection.period_type)} {selection.exercice - 1}.{' '}
            </>
          )}
          Montants en millions de FCFA, tels que publiés par les émetteurs. Quand l'exercice de
          comparaison est une perte ou nul, la variation est donnée en valeur (M FCFA) : un % serait trompeur.
        </div>
      </div>
    </Box>
  </div>
);

export default DesktopResults;
